<template>
  <bwr-form-field type="radio">
    <template v-for="option in options" :key="option.value">
      <div class="FormField__RadioLabel">
        <label>
          <input
            type="radio"
            :name="name"
            :value="option.value"
            class="FormField__RadioInput"
            :checked="value === option.value"
            :disabled="disabled"
            @change.stop="$emit('change', $event.target.value)"
          />
          <span class="FormField__RadioInputText">{{ option.label }}</span>
        </label>
        <a
          v-if="option.link"
          :href="option.link.href"
          class="Link FormField__RadioLink"
          >{{ option.link.text }}</a
        >
      </div>
    </template>
  </bwr-form-field>
</template>

<script>
import BwrFormField from './BaseFormField.vue'
export default {
  name: 'BwrRadio',
  components: {
    BwrFormField,
  },
  props: {
    value: {
      /* type is any */
      /* eslint-disable-line vue/require-prop-types, vue/require-default-prop */
    },
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.FormField__RadioLabel {
  display: block;
  margin-bottom: 8px;
}

.FormField__RadioLabel label {
  display: inline;
}

.FormField__RadioLabel input {
  appearance: none;
  display: none;
}

.FormField__RadioInputText {
  cursor: pointer;
  font-family: var(--font-family-rund);
  color: var(--color-forest-100);
  font-size: 15px;
  line-height: 24px;
}

.FormField__RadioInput + .FormField__RadioInputText::before {
  content: '';
  background-color: var(--color-white);
  box-shadow:
    inset 0 0 0 1px var(--color-lichen-150),
    inset 0 0 0 6px var(--color-white);
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  vertical-align: bottom;
  margin-right: 8px;
  transition:
    background-color 0.1s ease-in,
    box-shadow 0.1s ease-in;
}

.FormField__RadioInput[disabled] + .FormField__RadioInputText {
  color: var(--color-forest-50);
}

.FormField__RadioInput[disabled] + .FormField__RadioInputText::before {
  box-shadow:
    inset 0 0 0 1px var(--color-lichen-150),
    inset 0 0 0 6px var(--color-lichen-100);
  background-color: var(--color-lichen-100);
}

.FormField__RadioInput:checked + .FormField__RadioInputText::before {
  background-color: var(--color-forest-100);
}

.FormField__RadioInput[disabled]:checked + .FormField__RadioInputText::before {
  background-color: var(--color-forest-60);
}

.FormField__RadioLink {
  margin-left: 3px;
  font-size: 15px;
  line-height: 24px;
}

@media (--mq-phablet-and-up) {
  .FormField__RadioLink {
    margin-left: 5px;
  }
}
</style>
